// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/widgets/Loading/styles.css
// module id = 846
// module chunks = 0